import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  ListItem,
  OrderedList,
  Radio,
  RadioGroup,
  Text,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
// import interLogo from "../Assets/Images/interswitch_group_logo.svg.svg";
import paystackLogo from "../Assets/Images/paystackLogo.svg";
import remitalogo from "../Assets/Images/remita-logo.svg";
import { setFormModal } from "../redux/slices/modalSlice";
import { setloadTost } from "../redux/slices/toastSlice";
import { makePayment } from "../components/RemitaPayment";
// import { BASE_URL } from "../config/settings";
// import httpRequest from "../utils/httpRequest";
import {
  // setFeepaymentId,
  setFeePaymentDetail,
} from "../redux/slices/individualApplicationApprovalSlice";
import { setPaymentConfirmation } from "../redux/slices/studentApplicationApprovalSlice";
import {
  confirmRemitaPayment,
  generateRemitaPayment,
  initiatePaystackPayment,
} from "../redux/slices/paymentSlice";

const MemberProfilePaymentModal = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const paymentDetailsData = useSelector(
    (state) => state?.myDues?.myDuesDetails
  );

  const feePaymentId =
    useSelector(
      (state) => state?.individualApplicationApproval?.feepaymentId
    ) || paymentDetailsData?.feePaymentId;

  console.log("Fee Payment: ", feePaymentId);

  const paymentTypeData = [
    { title: "Remita", logo: remitalogo },
    // { title: "Interswitch", logo: interLogo },
    { title: "Paystack", logo: paystackLogo },
  ];

  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);
  const handlePaymentOptionChange = (value) => {
    setSelectedPaymentOption(value);
  };

  const successFunc = async (referenceId) => {
    try {
      const response = await dispatch(
        confirmRemitaPayment(referenceId)
      ).unwrap();
      if (!response?.isSuccess === true) {
        dispatch(
          setloadTost({
            title: "Error",
            description: `${response?.response?.data?.error?.description} `,
            status: "warning",
            duration: 5000,
            isClosable: true,
            position: "top",
          })
        );
      } else {
        dispatch(
          setloadTost({
            title: "Confirmation",
            description: `Verified Successfully `,
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top",
          })
        );
        dispatch(setPaymentConfirmation(true));
      }
    } catch (error) {
      console.error(error);
      dispatch(
        setloadTost({
          title: "Error",
          description: "An error occurred during confirmation.",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top",
        })
      );
    }
  };

  const handleSubmitPayment = async () => {
    if (selectedPaymentOption !== null) {
      if (selectedPaymentOption === "Remita") {
        try {
          setLoading(true);
          const response = await dispatch(
            generateRemitaPayment(feePaymentId)
          ).unwrap();
          if (response?.isSuccess) {
            dispatch(setFeePaymentDetail(response));
            dispatch(
              setFormModal({
                status: true,
                title: "Payment Details",
                type: "regPaymentDetails",
                data: response,
              })
            );
          } else {
            const errorMessage =
              response?.payload?.data?.error?.description ||
              "Failed to get fee payment";
            setError(errorMessage);
            dispatch(
              setloadTost({
                title: "Error",
                description: errorMessage,
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "top",
              })
            );
          }
        } catch (error) {
          setError(
            "Failed to get fee payment, please check your request/network"
          );
        } finally {
          setLoading(false);
        }
        makePayment({
          orderId: paymentDetailsData?.orderId,
          referenceId: paymentDetailsData?.referenceId,
          successFunc: successFunc,
        });
        dispatch(setFormModal({ status: false, data: null }));
      } else if (selectedPaymentOption === "Paystack") {
        try {
          setLoading(true);
          const response = await dispatch(
            initiatePaystackPayment(feePaymentId)
          ).unwrap();

          if (response?.isSuccess) {
            dispatch(setFeePaymentDetail(response));
            // window.location.href = response?.referenceUrl;
            window.open(response?.referenceUrl, "_blank");
          } else {
            const errorMessage =
              "Failed to get fee payment. Kindly try another payment method";
            setError(errorMessage);
            dispatch(
              setloadTost({
                title: "Error",
                description: error,
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "top",
              })
            );
          }
        } catch (err) {
          setError(
            "Failed to get fee payment, please check your request/network"
          );
        } finally {
          setLoading(false);
        }
        // makePayment({
        //   orderId: paymentDetailsData?.orderId,
        //   referenceId: paymentDetailsData?.referenceId,
        //   successFunc: successFunc,
        // });
        dispatch(setFormModal({ status: false, data: null }));
      }
    } else {
      dispatch(
        setloadTost({
          title: "Empty Field",
          description: `Please select a payment option `,
          status: "warning",
          duration: 5000,
          isClosable: true,
          position: "top",
        })
      );
    }
  };

  return (
    <Box py={"20px"} minH={"100vh"} maxWidth={"auto"}>
      <Box mt={5}>
        <Flex
          alignItems={"center"}
          gap={3}
          bgColor={"#D7343926"}
          px={["20px", "40px", "40px"]}
          py={"20px"}
        >
          <Text
            color={"#222B45"}
            fontWeight={"700"}
            fontSize={"14px"}
            lineHeight={"16px"}
          >
            Please Note
          </Text>
        </Flex>
        <Box bgColor={"#FFFFFF"} px={["20px", "40px", "40px"]} py={"30px"}>
          <Flex
            flexDirection={["column", "column", "column", "row"]}
            gap={["20px", "20px", "20px", "150px"]}
          >
            <Flex width={["100%", "100%", "100%", "30%"]}>
              <OrderedList
                fontSize={"13px"}
                fontWeight={"400"}
                lineHeight={"19.88px"}
                color={"#222B45"}
              >
                <ListItem mb={4}>
                  Please ensure your card is enabled for online payment by your
                  bank before proceeding
                </ListItem>
                <ListItem mb={4}>
                  A transaction may fail due to insufficient funds, wrong
                  credentials, card being blacklisted at issuer bank or network
                  failure. In the event of a network failure, kindly check with
                  your bank for any debits, before attempting again
                </ListItem>
                <ListItem mb={4}>
                  For Visa Card kindly use Remita Platform.
                </ListItem>
              </OrderedList>
            </Flex>
            <Flex
              flexDirection={"column"}
              width={["100%", "100%", "100%", "70%"]}
              gap={4}
            >
              <Text
                textAlign={"center"}
                color={"#222B45"}
                fontWeight={"400"}
                fontSize={"14px"}
                lineHeight={"21.41px"}
              >
                Use any of the options below to test the payment flow
              </Text>
              <RadioGroup
                value={selectedPaymentOption}
                onChange={handlePaymentOptionChange}
              >
                {paymentTypeData &&
                  paymentTypeData?.map((item, index) => (
                    <Flex
                      key={index}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      gap={5}
                      p={5}
                      w={"full"}
                      border={"1px solid #C4C4C4"}
                      borderRadius={"5px"}
                      mb={4}
                    >
                      <Flex alignItems={"center"} gap={5} width={"full"}>
                        <Radio value={item.title} colorScheme="green"></Radio>
                        <Text
                          color={"#222B45"}
                          fontWeight={"400"}
                          fontSize={"14px"}
                          lineHeight={"21.41px"}
                        >
                          {item?.title}
                        </Text>
                      </Flex>
                      <Image
                        src={item?.logo}
                        alt="payment logo"
                        width={["150px", "200px", "300px", "100px"]}
                        h={"40px"}
                      />
                    </Flex>
                  ))}
              </RadioGroup>
              <Button
                bgColor={"#D11A2A"}
                color={"#FFFFFF"}
                fontWeight={"700"}
                fontSize={"14px"}
                lineHeight={"21.41px"}
                borderRadius={"10px"}
                _hover={{ backgroundColor: "" }}
                _active={{ backgroundColor: "" }}
                onClick={handleSubmitPayment}
                isLoading={loading}
              >
                Pay
              </Button>
              {/* <Text
                textAlign={"center"}
                color={"#222B45"}
                fontWeight={"400"}
                fontSize={"14px"}
                lineHeight={"21.41px"}
              >
                Use another card
              </Text> */}
            </Flex>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default MemberProfilePaymentModal;
